(() => {
  const exhibit = document.querySelector('[data-exhibit]');
  const stage = exhibit?.querySelector('[data-paper-stage]');
  const artifact = exhibit?.querySelector('[data-artifact]');
  if (!exhibit || !stage || !artifact) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  let turn = 0;
  let frame = 0;
  const rotate = amount => {
    turn = Math.max(-18, Math.min(30, turn + amount));
    artifact.style.setProperty('--turn', turn + 'deg');
  };
  exhibit.querySelectorAll('[data-turn]').forEach(button => button.addEventListener('click', () => rotate(Number(button.dataset.turn))));
  artifact.querySelector('button')?.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      rotate(event.key === 'ArrowLeft' ? -12 : 12);
    }
  });
  stage.addEventListener('pointermove', event => {
    if (reduced.matches || !hover.matches) return;
    const box = stage.getBoundingClientRect();
    const x = Math.max(-.5, Math.min(.5, (event.clientX - box.left) / box.width - .5));
    const y = Math.max(-.5, Math.min(.5, (event.clientY - box.top) / box.height - .5));
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      artifact.style.setProperty('--rx', (8 - y * 18) + 'deg');
      artifact.style.setProperty('--ry', (x * 26) + 'deg');
    });
  });
  stage.addEventListener('pointerleave', () => {
    if (frame) cancelAnimationFrame(frame);
    artifact.style.setProperty('--rx', '8deg');
    artifact.style.setProperty('--ry', '0deg');
  });
  const image = exhibit.querySelector('[data-hero-image]');
  const editionButtons = [...exhibit.querySelectorAll('[data-hero-edition]')];
  editionButtons.forEach(button => button.addEventListener('click', () => {
    if (!image) return;
    image.src = button.dataset.src;
    image.dataset.full = button.dataset.src;
    image.alt = button.dataset.alt;
    exhibit.querySelector('[data-hero-year]').textContent = button.dataset.year;
    exhibit.querySelector('[data-hero-title]').textContent = button.dataset.title;
    exhibit.querySelector('[data-hero-publication]').textContent = button.dataset.publication;
    exhibit.querySelector('[data-hero-story]').dataset.storyOpen = button.dataset.story;
    editionButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    turn = 0;
    artifact.style.setProperty('--turn', '0deg');
    artifact.classList.remove('is-switching');
    requestAnimationFrame(() => artifact.classList.add('is-switching'));
  }));
  artifact.addEventListener('animationend', () => artifact.classList.remove('is-switching'));
  let scrollFrame = 0;
  const scroll = () => {
    if (reduced.matches || scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => {
      const box = exhibit.getBoundingClientRect();
      if (box.bottom > 0) exhibit.style.setProperty('--headline-drift', Math.min(65, Math.max(0, -box.top * .16)) + 'px');
      scrollFrame = 0;
    });
  };
  window.addEventListener('scroll', scroll, {passive:true});
})();
